/** @jsx jsx */
import { jsx } from "theme-ui";
import React from "react";
import { Link as GatsbyLink } from "gatsby";
import { Link } from "@theme-ui/components";
import { StyleProps } from "../../types/types";

export const isBrowser = typeof window !== "undefined";

function linkClick(to: string) {
  if (isBrowser && to.includes("#")) {
    const [anchorPath, anchor] = to.split("#");
  }
}

export type RockitLinkProps = {
  to: string;
  isNavLink?: boolean;
  target?: React.HTMLAttributeAnchorTarget;
  clickable?:boolean;
} & StyleProps;
export const RockitLink: React.FC<RockitLinkProps> = ({
  to,
  children,
  isNavLink = false,
  target = "_self",
  className,
  clickable=true,
  styleVariant,
}) => {
  if (!to) to = "/";

  const isExternal = /(http(s)?):\/\/*/.test(to);
  const isInternal = !isExternal; ///^(..\/|\/)(?!\/)/.test(to);

  isNavLink = isNavLink ? isNavLink : false;

  if (isInternal) {
    to = to.substring(0, 1) === "/" ? to : "/" + to;
  }

  if (isNavLink) {
    // console.log("in nav link", to);
    return (
      <GatsbyLink
        sx={{
          display: "inline-block",
          "&.active": {
            color: "primary",
          },
        }}
     
        partiallyActive={true}
        to={to}
        activeClassName="activex"
        onClick={() => {
         linkClick(to);
        }}
      >
        {children}
      </GatsbyLink>
    );
  }

  if (isInternal && !isNavLink) {
    return (
      <GatsbyLink
        target={target}
        to={to}
        onClick={() => {
          linkClick(to);
        }}
        className={className}
      >
        {children}
      </GatsbyLink>
    );
  } else {
    /* default external to blank target*/

    return (
      <Link className={className} href={to} target="blank">
        {children}
      </Link>
    );
  }

  return (
    <Link
      to={to}
      className={className}
      onClick={() => {
        linkClick(to);
      }}
    >
      {children}
    </Link>
  );
};

export default RockitLink;
